import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { normalize, getUrlParams } from '../../../helpers/pagination';

let validateToken;

const state = {
  breakdowns: {
    isBusy: false,
    data: [],
    error: null
  },
  breakdownDetails: {
    isBusy: false,
    data: [],
    error: null
  }
};

const mutations = {
  LOAD_BREAKDOWNS_BUSY: (state, payload) => {
    state.breakdowns.isBusy = payload;
  },
  LOAD_BREAKDOWNS_SUCCESS: (state, payload) => {
    state.breakdowns.data = payload;
    state.breakdowns.error = null;
    state.breakdowns.isBusy = false;
  },
  LOAD_BREAKDOWNS_FAIL: (state, payload) => {
    state.breakdowns.data = null;
    state.breakdowns.error = payload;
    state.breakdowns.isBusy = false;
  },

  LOAD_BREAKDOWN_DETAILS_BUSY: (state, payload) => {
    state.breakdownDetails.isBusy = payload;
  },
  LOAD_BREAKDOWN_DETAILS_SUCCESS: (state, payload) => {
    state.breakdownDetails.data = payload;
    state.breakdownDetails.error = null;
    state.breakdownDetails.isBusy = false;
  },
  LOAD_BREAKDOWN_DETAILS_FAIL: (state, payload) => {
    state.breakdownDetails.data = null;
    state.breakdownDetails.error = payload;
    state.breakdownDetails.isBusy = false;
  }
}

const actions = {
  getBreakdowns ({ commit, rootState }, { projectId }) {
    commit('LOAD_BREAKDOWNS_BUSY', true);

    const url = `${API_HOST}/analysis/${projectId}/standard_breakdowns`;

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.get(url, config)
      .then(r => {
        commit('LOAD_BREAKDOWNS_SUCCESS', r.data);
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
        console.error(error);
        commit('LOAD_BREAKDOWNS_FAIL', error);
      })
      .finally(() => {
        commit('LOAD_BREAKDOWNS_BUSY', false);
      });
  },

  getBreakdownDetails ({ commit, rootState, state }, { projectId, breakdownId }) {

    if (rootState.admin.breakdowns.breakdownDetails.isBusy) {
      this.validateToken.cancel('aborted');
    }

    commit('LOAD_BREAKDOWN_DETAILS_BUSY', true);

    const CancelToken = Axios.CancelToken;
    this.validateToken = CancelToken.source();

    const url = `${API_HOST}/analysis/${projectId}/standard_breakdowns/${breakdownId}`;

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
      cancelToken: this.validateToken.token
    };

    return Axios.get(url, config)
      .then(r => {
        commit('LOAD_BREAKDOWN_DETAILS_SUCCESS', r.data);
      })
      .catch(error => {
        if (error.message !== 'aborted') {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });
          console.error(error);
          commit('LOAD_BREAKDOWN_DETAILS_FAIL', error);
        }
      });
  },

  updateStandardBreakdownSettings ({ commit, rootState }, { projectId, breakdownId, settings, breakdownOptionName }) {
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    const body = { settings, breakdownOptionName };
    return Axios.put(`${API_HOST}/analysis/${projectId}/standard_breakdowns/${breakdownId}`, body, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        Vue.notify({ group: 'store_notifications', type: 'error', text: i18n.t('messages.request.error') });
        console.error(error);
        return error;
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};